<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  color?: string;
  orientation?: 'horizontal' | 'vertical';
  thickness?: number;
}

const props = withDefaults(defineProps<Props>(), {
  color: '#e2e8f0',
  orientation: 'horizontal',
  thickness: 1,
});

const dividerStyle = computed(() => {
  if (props.orientation === 'vertical') {
    return {
      backgroundColor: props.color,
      height: '100%',
      width: `${props.thickness}px`,
    };
  }

  return {
    backgroundColor: props.color,
    height: `${props.thickness}px`,
  };
});
</script>

<template>
  <div
    class="divider"
    :class="`divider--${orientation}`"
    :style="dividerStyle"
  />
</template>

<style scoped lang="scss">
.divider {
  &--horizontal {
    width: 100%;
  }
}
</style>
